import bindScroll from 'helpers/bindScroll';
import onNowLandscapeCarousel from '../components/onNowLandscapeCarousel';

export default function scheduleCarousel(carouselData, carouselElement, objs) {
    try {
        // Get current timezone for handling scheduled events
        let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        objs.push({
            wrapper: carouselElement,
            init: function () {
                carouselElement.on('init', () => {
                    carouselElement.removeClass('hidden');
                });

                carouselElement.on('setPosition', () => {
                    carouselElement.ellipsify();
                });

                let params = {
                    parentContainer: carouselElement,
                    options: {
                        endPoint: CBS.Registry.region.prefix + '/carousels/homepage/schedule/',
                        params: {
                            name: carouselData.title,
                            carouselId: carouselData.carouselId,
                            timeZone: localTimeZone
                        },
                        fetchData: true
                    }
                };

                onNowLandscapeCarousel(params);
            }
        });
    } catch (e) {}
}
